export const defaultOutOfOfficeChatButtonStyleProps = {
  iconStyleProps: {
    backgroundColor: "#000000"
  },
  subtitleStyleProps: {
    margin: "0px 10px 0px 10px"
  }
};